
//JS Not in use, when used as a component as the code is currently, the ng-model is not updating before the ng-change

export class PaymentToggleController {

    constructor(private $rootScope, private $element) { }

}
